/**
 * Angular core components declaration
 **/
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';

/**
 * User Role Modules declaration
 **/
import { LanguageModule } from '../common/services/languages/language.module';


import { RouterModule } from '@angular/router';
import { PhonePipe } from '../common/pipes/phone.pipe';

/**
 * User Role Services declaration
 **/
import { TranslationService } from '../common/services/languages/translation.service';
import { OrchestrationService } from './services/orchestration-service/orchestration.service';
import { HeaderInterceptorService } from './services/header-interceptor/header-interceptor.service';
import { SideNavService } from './services/sidenav-service/sidenav.service';


/**
 User Role Components declaration
 **/
import { UserRoleMainComponent } from './user-role-main/user-role-main.component';
import { UserRoleGetFormComponent } from './user-role-form/user-role-get-form/user-role-get-form.component';
import { UserRoleUpdateFormComponent } from './user-role-form/user-role-update-form/user-role-update-form.component';
import { UserRoleSideNavComponent } from './user-role-side-nav/user-role-side-nav.component';
import { UserRoleRoutingModule } from './user-role-routing.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [FormsModule,
    ReactiveFormsModule,
    LanguageModule,
    RouterModule,
    UserRoleRoutingModule,
    CommonModule, UserRoleMainComponent,
    UserRoleSideNavComponent,
    UserRoleGetFormComponent,
    UserRoleUpdateFormComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptorService, multi: true },
        TranslationService,
        SideNavService,
        PhonePipe,
        DatePipe,
        OrchestrationService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })

export class UserRoleModule {
  constructor() {
  }
}
